<div class="section" [@fadeIn]>
  <!-- Label -->
  <div class="row">
    <div class="custom">
      <ng-content></ng-content>
    </div>
  </div>

  <!-- Inputs -->
  <div class="row">
    <div class="col">
      <div class="row" *ngFor="let kba of block; let last = last; let bi = index; trackBy: trackByFn">
        <div
          [@flip]="block[bi][ki]"
          class="matrix-input-wrapper margin sm top right"
          [ngClass]="{ disabled: disabled }"
          *ngFor="let bitting of kba; let ki = index; trackBy: trackByFn"
        >
          <input
            #inputRef
            arrow-div
            (keyup)="onChange($event, bi, ki)"
            (focus)="setInputs($event)"
            maxlength="1"
            [ngClass]="{ disabled: disabled, border: inputError }"
            [disabled]="disabled"
            class="matrix-input uppercase"
            [(ngModel)]="block[bi][ki]"
            ondrop="return false;"
          />
        </div>
      </div>
    </div>
  </div>
</div>
